import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";    // 引入英文翻譯資源
import tw from "./zh-TW.json"; // 引入繁體中文翻譯資源
// import { Translation } from 'react-i18next'

// 引入用於在元件中使用翻譯的 hook
import { useTranslation } from "react-i18next"; 
// 引入用於檢測瀏覽器語言的插件
import LanguageDetector from "i18next-browser-languagedetector"; 
export const Translator = (content: string) => {
  // 使用 useTranslation hook 取得翻譯函式 t
  const { t } = useTranslation();
  return t(content); // 返回翻譯後的文字
};

// 定義不同語言的翻譯資源
const resources = {
  en: {
    translation: en, // 英文翻譯資源
  },
  "zh-TW": {
    translation: tw, // 繁體中文翻譯資源
  },
};
i18n.use(LanguageDetector); // 使用檢測瀏覽器語言的插件
i18n.use(initReactI18next).init({
  resources,
  lng: "en", //預設語言
  fallbackLng: "en", //如果當前切換的語言沒有對應的翻譯則使用這個語言，
  interpolation: {
    escapeValue: false,
  },
});
